import { render, staticRenderFns } from "./FileDetails.vue?vue&type=template&id=3f64c298&scoped=true"
import script from "./FileDetails.vue?vue&type=script&lang=js"
export * from "./FileDetails.vue?vue&type=script&lang=js"
import style0 from "./FileDetails.vue?vue&type=style&index=0&id=3f64c298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f64c298",
  null
  
)

export default component.exports